import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnpin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUnpin"><Path d="M15.9371 17.3515L21 22.4145L22.4142 21.0003L3.00003 1.58606L1.58582 3.00027L6.64882 8.06328L2.1488 9.56329L7.58582 15.0003L2.58582 20.0003L4.00003 21.4145L9.00003 16.4145L14.437 21.8515L15.9371 17.3515Z" fill="currentColor"/><Path d="M17.3402 13.142L17.3209 13.1999L10.8005 6.6794L10.8583 6.66012L14.3446 1.43066L22.5697 9.65573L17.3402 13.142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnpin;
